export default "__VITE_ASSET__643d3164__"